import React from 'react';
import { Filters } from 'src/components/Filters';
import {
  FiltersConfig,
  FilterType,
  Groups,
} from 'src/components/Filters/types';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { useMemo } from 'react';
import {
  getReceiptsViewFiltersData,
  receiptsResetControlFilters,
  receiptsSetControlFilters,
} from '../../../store/receiptsViewSlice';
import { RootState } from 'src/store';
import {
  ReceiptsControlFilter,
  ReceiptsControlFilters,
} from '../../../store/receiptsViewSlice/types';
import { getMonthsOptions } from '../../../store/receiptsViewSlice/utils';
import { vendorsOptions } from 'src/routes/Dashboard/store/services/mockData';

type OwnProps = {
  isDisabled?: boolean;
};

type Props = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps> &
  OwnProps;

const ReceiptsFilters: React.FC<Props> = ({
  isDisabled = false,
  filtersState,
  setFiltersControls,
  resetFilters,
}) => {
  const filters: FiltersConfig<ReceiptsControlFilter> = useMemo(
    () => ({
      main: [
        {
          field: 'freeText',
          label: '',
          type: FilterType.TextInput,
          groupBy: Groups.Category,
        },
        {
          field: 'date',
          label: 'חודש',
          type: FilterType.SingleSelect,
          groupBy: Groups.Date,
          options: getMonthsOptions(),
        },
        {
          field: 'vendor',
          label: 'ספק',
          type: FilterType.MultiSelect,
          groupBy: Groups.Category,
          options: vendorsOptions,
        },
      ],
    }),
    [getMonthsOptions, vendorsOptions],
  );

  const initialValues = useMemo<ReceiptsControlFilters>(
    () => ({
      date: filtersState?.date || null,
      vendor: filtersState?.vendor || null,
    }),
    [filtersState],
  );

  const valuesResetTo = useMemo<ReceiptsControlFilters>(
    () => ({
      date: null,
      vendor: null,
    }),
    [],
  );

  return (
    <Filters<ReceiptsControlFilter>
      formIsSubmittedOnFieldChange
      isDisabled={isDisabled}
      filtersConfig={filters}
      initialValues={initialValues}
      valuesResetTo={valuesResetTo}
      onSubmit={setFiltersControls}
      onResetFilters={resetFilters}
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  filtersState: getReceiptsViewFiltersData(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setFiltersControls: (payload: ReceiptsControlFilters) =>
    dispatch(receiptsSetControlFilters(payload)),
  resetFilters: () => dispatch(receiptsResetControlFilters()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReceiptsFilters);
